import { defineMessages } from 'react-intl-next';

export const messages: {
	liveDoc: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusUpdateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	talentExternalPositionKey: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	talentPositionTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveDoc: {
		id: 'live_doc_type',
		defaultMessage: 'Live Doc',
		description: 'Type text for live document',
	},
	statusUpdateTitle: {
		id: 'quick-find.mercury.focus-area-status-update.title',
		defaultMessage: 'Update for {focusAreaName}',
		description: 'Focus area status update title',
	},
	issue: {
		id: 'issue_type',
		defaultMessage: 'Work item',
		description: 'Type text for issue',
	},
	talentExternalPositionKey: {
		id: 'quick-find.talent.position.external-position-key',
		defaultMessage: 'External key {positionKey}',
		description: 'Position key for position',
	},
	talentPositionTitle: {
		id: 'quick-find.talent.position.title',
		defaultMessage:
			'{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
		description: 'Position title with position key',
	},
});
